export const types = [
  { name: "Caregiver", style: { background: "#f16548", color: "white" } },
  { name: "Creator", style: { background: "#f7921c", color: "white" } },
  { name: "Explorer", style: { background: "#81822e", color: "white" } },
  { name: "Hero", style: { background: "#0067ab", color: "white" } },
  { name: "Innocent", style: { background: "#00afdd", color: "white" } },
  { name: "Jester", style: { background: "#a5cd39", color: "white" } },
  { name: "Lover", style: { background: "#d92d68", color: "white" } },
  { name: "Magician", style: { background: "#91268e", color: "white" } },
  { name: "Everyperson", style: { background: "#008e97", color: "white" } },
  { name: "Revolutionary", style: { background: "#cd2738", color: "white" } },
  { name: "Ruler", style: { background: "#e7b708", color: "white" } },
  { name: "Sage", style: { background: "#81492c", color: "white" } }
];
